import { render, staticRenderFns } from "./IntensiveDetail.vue?vue&type=template&id=20cef292&scoped=true&"
import script from "./IntensiveDetail.vue?vue&type=script&lang=js&"
export * from "./IntensiveDetail.vue?vue&type=script&lang=js&"
import style0 from "./IntensiveDetail.vue?vue&type=style&index=0&id=20cef292&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cef292",
  null
  
)

export default component.exports